export default {
  SET_BUSY(state, busy) {
    state.busy = busy;
  },
  SET_API_URL(state, url) {
    state.baseApiUrl = url;
  },
  SET_ERROR_MESSAGE(state, message) {
    state.error.message = message;
  },
  SET_ERROR(state, errorParams) {
    state.error.message = errorParams.message;
    state.error.allowRefresh = errorParams.allowRefresh ?? false;
    state.error.allowClose = errorParams.allowClose ?? false;
  },
};
